/**
 * CLARTEXT — PRINT.1 (Juni 2026): DIN-Geometrie-Fundament (rein Frontend).
 *
 * mm-basierte Seitenmaße, feste Ränder + Print-Safe-Area, profilabhängige
 * Typografie/QR-Größe sowie die fail-closed Sektions-Priorität je Profil.
 *
 * STRIKT beweisneutral: KEINE Fachdaten, KEINE Backend-/Evidence-/WORM-/PDF-
 * Berührung. Reine Layout-Konstanten für die Plakat-Darstellung.
 */

// Echte DIN-Maße (Hochformat-Basis in mm).
export const DIN_FORMATS = {
  a4: { id: "a4", label: "A4", shortSide: 210, longSide: 297 },
  a3: { id: "a3", label: "A3", shortSide: 297, longSide: 420 },
};

export const ORIENTATIONS = {
  portrait: { id: "portrait", label: "Hochformat" },
  landscape: { id: "landscape", label: "Querformat" },
};

// Feste Ränder (Print-Safe-Area) je Format.
const MARGIN_MM = { a4: 12, a3: 16 };

// Profil-Typografie in px (an Blattgröße angelehnt) + QR-Kantenlänge + Mindest-
// Body-Schriftgröße (Lesbarkeit). A3 ist deutlich größer als A4.
const TYPO = {
  a4: { title: 30, h2: 16, body: 13, small: 11, qr: 116, minBody: 11 },
  a3: { title: 46, h2: 23, body: 17, small: 13, qr: 176, minBody: 13 },
};

// 1 mm bei 96 dpi (für optionale px-Umrechnungen).
export const MM_TO_PX = 96 / 25.4;

export function getDinProfile(format = "a4", orientation = "portrait") {
  const fmt = DIN_FORMATS[format] || DIN_FORMATS.a4;
  const isPortrait = orientation !== "landscape";
  const widthMm = isPortrait ? fmt.shortSide : fmt.longSide;
  const heightMm = isPortrait ? fmt.longSide : fmt.shortSide;
  const marginMm = MARGIN_MM[fmt.id] ?? 12;
  const typo = TYPO[fmt.id] || TYPO.a4;
  return {
    format: fmt.id,
    orientation: isPortrait ? "portrait" : "landscape",
    widthMm,
    heightMm,
    marginMm,
    safeWidthMm: widthMm - 2 * marginMm,
    safeHeightMm: heightMm - 2 * marginMm,
    cssPageSize: `${widthMm}mm ${heightMm}mm`,
    typo,
  };
}

// Fail-closed Sektions-Priorität (Reihenfolge = Wichtigkeit). Titel ist immer
// oben, der Pflichthinweis immer unten — beide sind NICHT Teil dieser Liste.
// A4 = Kurzplakat (verdichtet), A3 = Aushang (mehr Inhalt).
export const SECTION_PRIORITY = {
  a4: ["qr", "psa", "hazards", "rules"],
  a3: ["qr", "symbols", "hazards", "psa", "rules", "richtig_falsch"],
};

export function getSectionPriority(format) {
  return SECTION_PRIORITY[format] || SECTION_PRIORITY.a4;
}
